import { render, staticRenderFns } from "./ConfirmarEmergenciaCard.vue?vue&type=template&id=13a57972&scoped=true&"
import script from "./ConfirmarEmergenciaCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmarEmergenciaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a57972",
  null
  
)

export default component.exports